<!-- no permission -->
<section class="page-wrapper scroll-container" *ngIf="display === false">
  <h4>You do not have permission to view this content</h4>
</section>

<!-- no context-->
<section class="page-wrapper scroll-container" *ngIf="display && context === null">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</section>

<!-- client context -->
<lib-client-sub-nav *ngIf="display && context === 'client'" activeTab=""></lib-client-sub-nav>
<section *ngIf="display && context === 'client'" class="left-nav-wrapper bg-grey scroll-container">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</section>

<!-- NOTE: this is how a child component is instantiated
  <third-party-embed [content]="content" [minRole]="'CSR1'"></third-party-embed>
  <ng-template #content>
    -- content goes here --
    <iframe width="420" height="315"
    src="https://www.youtube.com/embed/tgbNymZ7vqY">
    </iframe>
    ----
  </ng-template>
 -->
